import React, { Fragment, Component } from 'react';
import { observer } from 'mobx-react';
import b_ from 'b_';
import { CategoryFilterStore } from '../../stores/BrowserPolicies/ContentFilteringStore';
import CategoryLookup from '../CategoryLookup';
import {
    ConsoleCard,
    ConsoleCardTitle,
    ConsoleList,
    ConsoleListAction,
} from '../ConsoleFragments';
import FuseInfoTooltip from '../FuseControls/FuseTooltip/FuseInfoTooltip';
import './FilterBy.css';

const block = b_.lock('FilterBy');

class FilterByCategory extends Component {
    static propTypes = {
        categoryFilterStore: CategoryFilterStore.PropType.isRequired,
    };

    render() {
        const { categoryFilterStore } = this.props;

        return <ConsoleCard>
            <ConsoleCardTitle>
                FILTER BY CATEGORY
                <FuseInfoTooltip inline>
                    Specify which web categories to allow or block when a web page is requested.
                </FuseInfoTooltip>
            </ConsoleCardTitle>
            <CategoryLookup
                className={block('SearchField')}
                placeholder={'Search by Name or Domain'}
                inputStore={categoryFilterStore.categorySearchStore}
                searchResultStore={categoryFilterStore.searchedDomainCategoryIds}
            />
            <div className={block('Row')}>
                <div className={block('Column')}>
                    <ConsoleList
                        className={block('List')}
                        title={`Allowed Categories (${categoryFilterStore.getAllowedCount()})`}
                    >
                        {categoryFilterStore.getFilteredAllowedCategories().map(({ id, name }) => <Fragment key={id}>
                            <div
                                className={block('ListItem', { left: true })}
                                title={name}
                            >{name}</div>
                            <ConsoleListAction
                                onClick={() => categoryFilterStore.forbiddenCategories.push(id)}
                            >{'Block >'}</ConsoleListAction>
                        </Fragment>)}
                    </ConsoleList>
                    <ConsoleListAction
                        global
                        onClick={categoryFilterStore.blockAll}
                    >{'BLOCK ALL >>'}</ConsoleListAction>
                </div>
                <div className={block('Column')}>
                    <ConsoleList
                        className={block('List')}
                        title={`Blocked Categories (${categoryFilterStore.getBlockedCount()})`}
                    >
                        {categoryFilterStore.getFilteredBlockedCategories().map(({ id, name }) => <Fragment key={id}>
                            <ConsoleListAction
                                onClick={() => categoryFilterStore.forbiddenCategories.remove(id)}
                            >{'< Allow'}</ConsoleListAction>
                            <div className={block('ListItem', { right: true })}>{name}</div>
                        </Fragment>)}
                    </ConsoleList>
                    <ConsoleListAction
                        global
                        onClick={categoryFilterStore.allowAll}
                    >{'<< ALLOW ALL'}</ConsoleListAction>
                </div>
            </div>
        </ConsoleCard>;
    }
}

export default observer(FilterByCategory);
